var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._b({attrs:{"items":this.items,"hide-details":"","return-object":"","outlined":"","dense":""},on:{"change":_vm.onChange},model:{value:(_vm.select),callback:function ($$v) {_vm.select=$$v},expression:"select"}},'v-select',{ ..._vm.$props, ..._vm.$attrs },false))
}
var staticRenderFns = []

export { render, staticRenderFns }